module.exports = __webpack_public_path__ + "img/welding-1.9f736553.jpg";